$('.site-footer__linklist > .site-footer__linklist-item--category-link').on('click', function (e) {
  e.preventDefault();
  if ($(this).parents('.site-footer__linklist').hasClass('active')) {
    $(this).parents('.site-footer__linklist').removeClass('active');
  } else {
    $('.site-footer__linklist').removeClass('active');
    $(this).parents('.site-footer__linklist').addClass('active');
  }
});